import { Typography } from '@mui/material';
import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

import Modal, { ModalBody, ModalHeader } from '@/components/common/Modal/Modal';
import { FQ_BUTTON_VARIANTS } from '@/components/muiCustomized/FQButton/constant';
import FQButton from '@/components/muiCustomized/FQButton/FQButton';
import { COLOR, FONT_SIZE, FONT_WEIGHT, MEDIA_QUERIES_BREAKPOINTS, PX_TO_REM } from '@/globalStyles';
import { ROUTES } from '@/pages/Routing/Routing';
import { ReactComponent as SuccessImage } from '@/resources/image/People_with_mountains.svg';

const SuccessModal = ({ isOpen, onReset }) => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    return (
        <StyledModal open={isOpen} onClose={onReset} hero={<></>}>
            <SuccessWrapper>
                <SuccessImage width={272} />
                <TitleContainer>
                    <MainTitle>{t('newRequest_form_request_was_sent')}!</MainTitle>
                    <MessageContent>{t('new_request_modal_success_content_message')}</MessageContent>
                </TitleContainer>
                <SuccessButtonsWrapper>
                    <FQButton
                        data-variant={FQ_BUTTON_VARIANTS.fqOutline}
                        color="fqRed"
                        onClick={() => {
                            navigate(ROUTES.REQUESTS);
                        }}
                    >
                        {t('dashboardSection_pendingrequestsQuantity_headerTitle')}
                    </FQButton>
                    <FQButton data-variant={FQ_BUTTON_VARIANTS.fqPrimary} color="fqRed" onClick={onReset}>
                        <Typography variant="button">{t('button_text_close')}</Typography>
                    </FQButton>
                </SuccessButtonsWrapper>
            </SuccessWrapper>
        </StyledModal>
    );
};

const SuccessWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1.25rem;
`;

const SuccessButtonsWrapper = styled.div`
    display: flex;
    gap: 1.25rem;
    flex-wrap: wrap;
    justify-content: center;

    > button {
        width: fit-content;
        min-width: 7.5rem;
    }

    @media screen and (width <= ${MEDIA_QUERIES_BREAKPOINTS.mobile}px) {
        > button {
            width: 100%;
            max-width: none;
        }
    }
`;

const Memoized = memo(SuccessModal);
const Styled = styled(Memoized)``;

const StyledModal = styled(Modal)`
    ${ModalBody} {
        box-sizing: border-box;
        padding-bottom: 3.4375rem;
        padding-top: 1rem;
        width: 650px;

        @media screen and (width <= ${MEDIA_QUERIES_BREAKPOINTS.tablet}px) {
            width: auto;
        }
    }

    ${ModalHeader} {
        padding-right: ${PX_TO_REM[16]};
    }
`;

const MainTitle = styled.div`
    color: ${COLOR.black};
    font-size: 1.0625rem;
    font-weight: ${FONT_WEIGHT.medium};
    line-height: 1.375rem;
    letter-spacing: 0.04375rem;
`;

const MessageContent = styled.div`
    color: ${COLOR.suvaGrey};
    font-size: ${FONT_SIZE.smedium};
    font-weight: ${FONT_WEIGHT.normal};
    line-height: 1.40625rem;
    letter-spacing: 0.0125;
    margin-top: 0;
    text-align: center;
`;

const TitleContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 0.5rem;
    margin-bottom: 0.5rem;
`;

export default Styled;
